/**
 * CMCD object header name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_OBJECT = 'CMCD-Object';
